import { useFormField } from '@calendly/form'

import { SearchableSelectField as RawSearchableSelectField } from './raw/searchable-select-field'

export const SearchableSelectField = (props) => {
  const [fieldProps, meta, { setValue, setTouched, setError }] = useFormField(props)

  const errorToUse = typeof props.error === 'string' ? props.error : meta.error

  const onChangeHandler = (value) => {
    setValue(value)
    setTouched(true)
    setError(undefined)
    props.onChange?.(value)
  }

  return (
    <RawSearchableSelectField
      {...fieldProps}
      onChange={onChangeHandler}
      error={errorToUse}
    />
  )
}
